import { createIcon } from '@chakra-ui/icons';

export const TrackArticle = createIcon({
  displayName: 'TrackArticle',
  viewBox: '0 0 20 20',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect width="20" height="20" rx="10" fill="#FDE9C8" />
      <g clipPath="url(#clip0_307_12835)">
        <path
          d="M14.0625 5.3125H5.9375V14.6875H14.0625V5.3125Z"
          stroke="#977334"
          strokeWidth="0.83"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9375 7.1875H12.1875"
          stroke="#977334"
          strokeWidth="0.83"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9375 9.0625H12.1875"
          stroke="#977334"
          strokeWidth="0.83"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.8125 10.9375H12.1875"
          stroke="#977334"
          strokeWidth="0.83"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.8125 12.8125H12.1875"
          stroke="#977334"
          strokeWidth="0.83"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.6875 7.1875H7.8125V9.0625H9.6875V7.1875Z"
          stroke="#977334"
          strokeWidth="0.83"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_307_12835">
          <rect width="10" height="10" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
